<template>
  <div id="legendHandler" :class="{ legendBtnCollapsed: isHidden }">
    <div class="titleBar" :title="$t('map.legend.tooltip')" @click.stop="$emit('toggleHandler')">
      <div class="titleIcon">
        <span class="glyphicons glyphicons-list"></span>
      </div>
      {{ $t('map.legend.title') }}
    </div>

    <div class="legendList">
      <p v-if="legendEntries.length === 0" class="emptyMessage">{{ $t('map.legend.empty') }}</p>
      <ul v-else>
        <li v-for="entry in legendEntries" :key="entry.mpTypeCode">
          <img class="legendIcon" :src="entry.iconSrc" :alt="entry.description" />
          <span class="legendLabel" :title="entry.description">{{ entry.description }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'legendHandler',
  props: {
    isHidden: {
      type: Boolean,
      required: true
    },
    legendEntries: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="less">
.legendBtnCollapsed {
  height: 38px !important;
  width: 38px !important;
  overflow: hidden;
  cursor: pointer;
  transition: 0.3s;
}

.legendBtnCollapsed:hover {
  transform: scale(0.9);
}

#legendHandler {
  position: absolute;
  z-index: 1;
  bottom: 10px;
  left: 108px;
  width: 260px;
  // However narrow the map gets, keep the panel inside it with the same 10px it has at the bottom.
  max-width: calc(100% - 118px);
  height: auto;
  max-height: 45%;
  background-color: #eee;
  transition: 0.3s;
  display: flex;
  flex-direction: column;

  .titleBar {
    background-color: @primaryGreen;
    padding: 10px;
    padding-left: 40px;
    color: @white;
    position: relative;
    cursor: pointer;
    flex: 0 0 auto;

    .titleIcon span {
      position: absolute;
      left: 0px;
      top: 0px;
      line-height: 27px;
      font-size: 20px;
      width: 38px;
      text-align: center;
    }
  }

  .legendList {
    padding: 10px;
    overflow-y: auto;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .legendIcon {
      flex: 0 0 32px;
      width: 32px;
      height: 32px;
    }

    .legendLabel {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .emptyMessage {
      margin: 0;
      color: @gray600;
    }
  }
}
</style>
